module.exports = __webpack_public_path__ + "static/img/banner-skd.5350e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-skd.png
// module id = Cfzn
// module chunks = 1